import { render, staticRenderFns } from "./Datepicker.vue?vue&type=template&id=28480cee"
import script from "./Datepicker.vue?vue&type=script&lang=js"
export * from "./Datepicker.vue?vue&type=script&lang=js"
import style0 from "./Datepicker.vue?vue&type=style&index=0&id=28480cee&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {IconCloseAccent: require('/app/components/icons/IconCloseAccent.vue').default,IconCalendarCheck: require('/app/components/v2/icons/IconCalendarCheck.vue').default,VDatePicker: require('/app/node_modules/vuetify/lib/components/VDatePicker/VDatePicker.js').default})


/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VDatePicker } from 'vuetify/lib/components/VDatePicker';
installComponents(component, {VDatePicker})


/* vuetify-loader */
import installDirectives from "!../../node_modules/vuetify-loader/lib/runtime/installDirectives.js"
import ClickOutside from 'vuetify/lib/directives/click-outside'
installDirectives(component, {ClickOutside})
